(() => {
  if (window.cardGridContactPreselectInitialized) return;
  window.cardGridContactPreselectInitialized = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-contact-option][href^="#"]');
    if (!trigger) return;

    const targetId = decodeURIComponent(trigger.hash.slice(1));
    const target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    const contactSection = target.matches('.contact-form-section')
      ? target
      : target.nextElementSibling?.matches('.contact-form-section')
        ? target.nextElementSibling
        : target.closest('.contact-form-section');
    if (!contactSection) return;

    const fieldHandle = trigger.dataset.contactField;
    const requestedOption = trigger.dataset.contactOption.trim().toLowerCase();
    const select = Array.from(contactSection.querySelectorAll('select[data-contact-field]')).find(
      (field) => field.dataset.contactField === fieldHandle
    );
    if (!select) return;

    const matchingOption = Array.from(select.options).find(
      (option) => option.value.trim().toLowerCase() === requestedOption
    );
    if (!matchingOption) return;

    select.value = matchingOption.value;
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
